/* Change this file to get your personal Portfolio */

// Summary And Greeting Section

import emoji from "react-easy-emoji";

const illustration = {
  animated: true // set to false to use static SVG
};

const greeting = {
  username: "Kevin Lupera",
  title: "Hola a todos. Soy Kevin Lupera",
  subTitle: emoji(
    "Un apasionado desarrollador de software 🚀 que tiene la experiencia de crear aplicaciones web y móviles con PHP / Android / Java / Python / R / Javascript / ... y algunas otras librerias y frameworks geniales!"
  ),
  resumeLink:
    "https://ugye-my.sharepoint.com/:b:/g/personal/kevin_luperab_ug_edu_ec/EfRLseOzYmtNjavz_kDZYlEB16oVjslfpEm8fI1382pszA?e=mZTyF3",
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/kevinlupera",
  linkedin: "https://www.linkedin.com/in/kevin-lupera/",
  gmail: "kevinlupera@gmail.com",
  gitlab: "https://gitlab.com/kevinlupera",
  //facebook: "https://www.facebook.com/saad.pasta7",
  medium: "https://medium.com/@kevinlupera",
  stackoverflow: "https://stackoverflow.com/users/15937425/kevin-lupera",
  // Instagram and Twitter are also supported in the links!
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "Lo que hago",
  subTitle:
    "Desarrollador fanático de las nuevas tecnología y apasionado de la automatización de procesos de todo tipo",
  skills: [
    emoji(
      "⚡ Desarrolle interfaces front-end / usuario altamente interactivas para sus aplicaciones web y móviles."
    ),
    emoji(
      "⚡ Integración de servicios de terceros como Firebase / OVH / Digital Ocean"
    ),
    emoji(
      "⚡ Integration of third party services such as Firebase/ AWS / Digital Ocean"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "php",
      fontAwesomeClassname: "fab fa-php"
    },
    {
      skillName: "symfony",
      fontAwesomeClassname: "fab fa-symfony"
    },
    {
      skillName: "laravel",
      fontAwesomeClassname: "fab fa-laravel"
    },
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "yarn",
      fontAwesomeClassname: "fab fa-yarn"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    }
    /*{
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire"
    },*/
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Universidad de Guayaquil",
      logo: require("./assets/images/UGlogo.png").default,
      subHeader: "Ingeniería en sistemas computacionales",
      duration: "2014 - 2019",
      desc: "",
    },
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "90%"
    },
    {
      Stack: "Programming",
      progressPercentage: "90%"
    },
    {
      Stack: "Automatizando procesos",
      progressPercentage: "80%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Líder Técnico",
      company: "Grupo Link",
      companylogo: require("./assets/images/grupolink.png").default,
      date: "Feb 2021 – Presente",
      desc:
        "Definir los requerimientos en conjunto con el cliente, las tareas e implementación del proyecto así como también la asignación del tiempos. Planificación y control de proyectos."
    },
    {
      role: "Desarrollador Web",
      company: "Grupo Link",
      companylogo: require("./assets/images/grupolink.png").default,
      date: "Nov 2019 – Ene 2021",
      desc:
        "Desarrollador del sitio web de Mi Claro y otros proyectos de la empresa de telecomunicaciones. Levantamiento y documentación de las necesidades de los usuarios para el desarrollo de soluciones tecnológicas. Realizar desarrollos de sistemas informáticos en base a los requerimientos de los usuarios."
    },
    {
      role: "Software Engineer",
      company: "UEES",
      companylogo: require("./assets/images/ueesLogo.jfif").default,
      date: "Ago 2018 – Oct 2019",
      desc:
        "Desarrollo de un e-commerce utilizando Elastic Search para una gran empresa multinacional y soluciones a nivel de base de datos para una gran empresa de telecomunicaciones.",
      /*descBullets: [
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      ]*/
    },
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Proyectos destacados",
  subtitle: "ALGUNAS EMPRESAS QUE AYUDO A CREAR SU TECNOLOGÍA",
  projects: [
    {
      image: require("./assets/images/inyectorespbm.png").default,
      projectName: "Inyectores PBM",
      projectDesc:
        "Es un laboratorio especializado en el mantenimiento de inyectores a gasolina electrónico mecánico alta precisión y cambio de aceite por succión.",
      footerLink: [
        {
          name: "Visita el Website",
          url: "https://inyectorespbm.com/"
        }
      ]
    },
    {
      image: require("./assets/images/ladisputa.png").default,
      projectName: "La Disputa",
      projectDesc:
        "La Disputa es una iniciativa comunicacional abierta y crítica, con el fin de promover la discusión de los diferentes temas que atañen a la sociedad ecuatoriana y global.",
      footerLink: [
        {
          name: "Visita el Website",
          url: "https://ladisputa.org/"
        }
      ]
    },
    {
      image: require("./assets/images/calculadora.png").default,
      projectName: "Calculadora",
      projectDesc:
        "Calculadora realizada en React.JS usando CI/CD con GitLab como resultado de la certificación de GitLab Associate.",
      footerLink: [
        {
          name: "Visita el Website",
          url: "https://kevinlupera.gitlab.io/calculator-kalb/"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Logros - Certificaciones 🏆 "),
  subtitle:
    "Logros, certificaciones Cartas de premios y algunas cosas geniales que he hecho.",

  achievementsCards: [
    {
      title: "Google Analytics Individual Qualification",
      subtitle: "Certificación profesional de Google",
      image: require("./assets/images/analytics.webp").default,
      footerLink: [
        {
          name: "Certificado",
          url: "https://skillshop.exceedlms.com/student/award/47981649"
        },
        {
          name: "Curso avanzado de Google Analytics ",
          url:
            "https://analytics.google.com/analytics/academy/certificate/V-JIQ2fkSnyMbEcLBPctnA"
        },
      ]
    },
    {
      title: "GitLab Certified Associate",
      subtitle:
        "GitLab",
      image: require("./assets/images/gitlab.png").default,
      footerLink: [
        {
          name: "Certificado",
          url:
            "https://badgr.com/public/assertions/6tv79bh1QNmXHh8X7aNkHw"
        }
      ]
    },
    {
      title: "DIPLOMADO EN DESARROLLO DE SITIOS WEB Y APLICACIONES MÓVILES",
      subtitle:
        "Fundación Carlos Slim.",
      image: require("./assets/images/CarlosSlim.jfif").default,
      footerLink: [
        {
          name: "Certificado",
          url:
            "https://capacitateparaelempleo.org/verifica_diplomado/VA1C4QAJS/"
        }
      ]
    },
    {
      title: "Data Processing Using Python",
      subtitle: "Nanjing University y ofrecido a través de Coursera",
      image: require("./assets/images/coursera.png").default,
      footerLink: [
        {
          name: "Certificado",
          url: "https://www.coursera.org/account/accomplishments/certificate/RJGCX4TV5J4W"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle: "Una buena forma de expresar mis ideas.",
  blogs: [
    {
      url:
        "https://kevinlupera.medium.com/como-construir-tu-marca-personal-en-internet-e9bb684bab78",
      title: "Como construir tu marca personal en internet",
      description:
        "Como todos saben cuando se busca un trabajo es importante tener una buena hoja de vida, pero tambien muchas empresas grandes e importantes..."
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/kevinlupera-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    ""
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contáctame ☎️"),
  subtitle:
    "Discutir un proyecto o simplemente quiero saludar, mi bandeja de entrada está abierta para todos.",
  number: "+593-998453560",
  email_address: "kevinlupera@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

export {
  illustration,
  greeting,
  socialMediaLinks,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails
};